import {showToastError, showGenericErrorMessage} from 'global/utils/toast';

export const onError = (error: any) => {
    const {response} = error;
    const {data} = response || {};

    if (data?.message && response?.status !== 500) {
        showToastError(data.message);
        return;
    }

    showGenericErrorMessage();
};
